import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getData,
  changeDate,
  changeType,
  changeVsMorD,
  changeTypeData,
  getSelect,
  changeSelectStatusChart,
  getChart,
  getByYears,
} from "../actions/dealerProfile";
import moment from "moment";
import {
  Radio,
  PageHeader,
  Button,
  DatePicker,
  Spin,
  message as messageAntd,
} from "antd";
import {
  LoadingOutlined,
  LineChartOutlined,
  LayoutOutlined,
} from "@ant-design/icons";
import "./dealerProfile.css";
import {
  mesesArrayL as months,
  mesesArrayS as shortMonths,
} from "../helpers/const";

import TableDP from "../components/tableDP";
import ChartDP from "../components/chartDP";

function DealerProfile(props) {
  const loading = useSelector((state) => state.dealerProfile.loading);
  const year = useSelector((state) => state.dealerProfile.year);
  const month = useSelector((state) => state.dealerProfile.month);
  const type = useSelector((state) => state.dealerProfile.type);
  const typeData = useSelector((state) => state.dealerProfile.typeData);
  const vsMorD = useSelector((state) => state.dealerProfile.vsMorD);
  const data = useSelector((state) => state.dealerProfile.data);
  const dataChart = useSelector((state) => state.dealerProfile.dataChart);
  const select = useSelector((state) => state.dealerProfile.select);
  const selectStatusChart = useSelector(
    (state) => state.dealerProfile.selectStatusChart
  );

  const dispatch = useDispatch();
  const currentDay = Number(moment().format("D"));
  const currentMonth = Number(moment().format("M"));
  const currentYear = Number(moment().format("YYYY"));

  useEffect(() => {}, []);

  function loadDataChart(type) {
    if (type == "hos") {
      dispatch(
        getByYears(
          type,
          selectStatusChart[type].idBrand,
          selectStatusChart[type].year
        )
      );
      localStorage.setItem(
        "selectStatusChartV2",
        JSON.stringify(selectStatusChart)
      );
    } else if (
      selectStatusChart[type].idIndicator != null &&
      selectStatusChart[type].idBrand != null &&
      selectStatusChart[type].year != null
    ) {
      dispatch(
        getChart(
          type,
          selectStatusChart[type].idIndicator,
          selectStatusChart[type].idBrand,
          selectStatusChart[type].year
        )
      );
      localStorage.setItem(
        "selectStatusChartV2",
        JSON.stringify(selectStatusChart)
      );
    } else {
      messageAntd.warning("Todos los campos son necesarios");
    }
  }

  function onChangeSelectStatusChart(type, select, value) {
    dispatch(changeSelectStatusChart(type, select, value));
  }

  function onChangeDate(date, dateString) {
    if (date != null) {
      dispatch(
        changeDate(Number(date.format("YYYY")), Number(date.format("M")))
      );
    } else {
      dispatch(changeDate(0, 0));
    }
  }

  function onChangeData() {
    if (year > 0 && month > 0) {
      dispatch(getData(year, month, type, vsMorD));
    } else {
      messageAntd.warning("Todos los campos son necesarios");
    }
  }

  function onChangeType(e) {
    dispatch(changeType(e.target.value));
  }

  function onChangeTypeData(e) {
    if (e.target.value === 1) {
      if (!select.new) {
        dispatch(getSelect());
      }
    }
    dispatch(changeTypeData(e.target.value));
  }

  function onChangeVsMorD(e) {
    dispatch(changeVsMorD(e.target.value));
  }

  return (
    <div style={{ margin: "18px" }}>
      <Spin
        spinning={loading}
        tip="Cargando..."
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        <PageHeader
          className="m-page-header"
          style={{ paddingBottom: "20px" }}
          onBack={null}
          title={
            <div style={{ fontSize: "18px" }}>
              Resumen Ejecutivo de Operación | Grupo Optima{" "}
            </div>
          }
          subTitle={null}
          extra={[
            typeData === 0 &&
            currentMonth === month &&
            currentYear === year &&
            Object.keys(data).length !== 0 ? (
              <Radio.Group key={0} value={vsMorD} onChange={onChangeVsMorD}>
                <Radio.Button value={1}>vs. Día actual</Radio.Button>
                <Radio.Button value={0}>vs. Mes</Radio.Button>
              </Radio.Group>
            ) : null,
            typeData === 0 && Object.keys(data).length !== 0 ? (
              <Radio.Group key={1} value={type} onChange={onChangeType}>
                <Radio.Button value={2}>
                  vs. Presupuesto {months[month]} {year}
                </Radio.Button>
                <Radio.Button value={1}>
                  vs.{" "}
                  {months[month - 1] !== "Unknow"
                    ? months[month - 1]
                    : months[12]}{" "}
                  {months[month - 1] !== "Unknow" ? year : year - 1}
                </Radio.Button>
                <Radio.Button value={0}>
                  vs. {months[month]} {year - 1}
                </Radio.Button>
              </Radio.Group>
            ) : null,
            <Radio.Group key={2} value={typeData} onChange={onChangeTypeData}>
              <Radio.Button value={0}>
                <LayoutOutlined />
              </Radio.Button>
              <Radio.Button value={1}>
                <LineChartOutlined />
              </Radio.Button>
            </Radio.Group>,
            typeData === 0 ? (
              <DatePicker
                key={3}
                onChange={onChangeDate}
                placeholder="Fecha"
                style={{ width: 120, marginRight: "8px" }}
                picker={typeData === 0 ? "month" : "year"}
              />
            ) : null,
            typeData === 0 ? (
              <Button key={4} type="primary" onClick={onChangeData}>
                Consultar
              </Button>
            ) : null,
          ]}
        />

        <div className="dp-table-container">
          {typeData === 0 ? (
            <TableDP
              vsMorD={vsMorD}
              date={`${
                currentMonth === month && currentYear === year
                  ? currentDay + "/"
                  : ""
              }${shortMonths[month]}/${year}`}
              data={data.result ? data.result : []}
              headers={data.headers ? data.headers : []}
            />
          ) : (
            <ChartDP
              select={select}
              selectStatusChart={selectStatusChart}
              onChangeSelectStatusChart={onChangeSelectStatusChart}
              dataChart={dataChart}
              loadData={loadDataChart}
            />
          )}
        </div>
      </Spin>
    </div>
  );
}

export default DealerProfile;
